import TextField from '@mui/material/TextField';
import React from 'react';

const FramiInput = ({ value, onChange, label, className, error, helperText, onBlur, dataCy, ...rest }) => {
    return (
        <TextField
            {...rest}
            className={className}
            style={{ width: '100%' }}
            size="small"
            variant="outlined"
            value={value}
            onChange={onChange}
            label={label}
            error={Boolean(error)}
            helperText={helperText}
            onBlur={onBlur}
            data-cy={dataCy}
        />
    );
};

export default FramiInput;
